import { useState } from "react";
import {
  Avatar,
  Box,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  Button
} from "@mui/material";
import InstagramLink from "../../common/InstagramLink";
import { useNavigate } from "react-router";
import AreYouSure from "../../common/AreYouSure";
import useNotification from "../../../hooks/useNotification";
import { useUserContext } from "../../../contexts/ProviderProvider";
import TransferModal from "./TransferModal";
import { matcher } from "../../../API/roster";
import ScoutTeam from "../../common/ScoutTeam";
import { sendToTransferPortal } from "../../../API/transferPortal";

const UnMatchedTable = (props) => {
  const navigate = useNavigate();
  const user = useUserContext();
  const notify = useNotification();
  const [action, setAction] = useState(undefined);
  const [transfer, setTransfer] = useState(undefined);

  const getGoogleLink = (university, sport) => {
    if (university === undefined && sport === undefined) {
      return ""
    }
    var search_link = "https://www.google.com/search?q=" + university
    if (sport.includes("(M)")) {
      search_link += "+" + "Mens" + "+" + sport.replace("(M)", "") + "+roster"
    }
    else if (sport.includes("(W)")) {
      search_link += "+" + "Womens" + "+" + sport.replace("(W)", "") + "+roster"
    }
    else if (sport.includes("&")) {
      search_link += "+" + sport.replace("&", "and") + "+roster"
    }
    else {
      search_link += "+" + sport + "+roster"
    }
    search_link = search_link.replace(new RegExp(' ', 'g'), "+")
    return search_link
  }

  const buildAYSMessage = (action) => {
    if (action.action === "create") {
      return (
        "Are you sure you want to create a new roster spot for " +
        action.new.roster.full_name +
        "?"
      );
    }
  };

  const matchRecords = (type, existing) => {
    const payload = { action: type, existing, new: props.data[props.selectedIndex] };

    setAction(payload);
  };

  const sendToTransferPortalAction = (reason) => {
    const athlete = props.data[props.selectedIndex];
    console.log('Transfer athlete', athlete, reason);

    sendToTransferPortal(
      user,
      athlete.roster.idAthleteMerchInfo,
      reason,
    )
      .then((response) => {
        // console.log('Successful transfer initiated',response);
        notify({ msg: response.data.Response, variant: "success" })
        props.reload();
        props.resetSelected();
      })
      .catch((error) => {
        // console.log(error);
        notify("Failed to complete transfer");
        props.reload();
        props.resetSelected();
      })
    setTransfer(undefined)
  }

  const actionMappings = {
    create: "add",
    merge: "assign",
    replace: "reassign",
    disconnect: "un-assign",
    malicious:"malicious",
  };

  const takeAction = (payload) => {
    const newRosterId = payload.new.roster.idAthleteMerchInfo

    payload = { action: payload.action, old: 0, new: newRosterId };

    matcher(0, newRosterId, payload.action, user, () => {
      props.reload();
      props.resetSelected();
    })
      .then((response) => {
        notify({
          msg: `${actionMappings[payload.action]}ed roster record`,
          variant: "success",
        });
        props.reload();
        props.resetSelected();
      })
      .catch((error) => {
        console.error(error);
        notify(`Failed to ${actionMappings[payload.action]} roster record`);
        props.reload();
        props.resetSelected();
      });

    setAction(undefined);
  };

  const aYSYes = () => {
    takeAction(action);
  };

  if (!props.data[props.selectedIndex]) {
    return <div>empty</div>
  }

  return (
    <div sx={{ width: "100%" }}>
      <div style={{ color: "#868686", opacity: "87%" }}>
        Selected Athlete Meta-Data
      </div>
      <Box
        sx={{
          padding: "5px",
          backgroundColor: "background.paper",
          marginTop: "10px",
          maxWidth: "370px",
        }}
      >
        <div style={{ color: "#888888" }}>Time signed up:</div>
        <div style={{ marginLeft: "100px" }}>
          {props.data[props.selectedIndex].user?.creationTimestamp}
        </div>
        <div style={{ color: "#888888" }}>Contract Signed At:</div>
        <div style={{ marginLeft: "100px" }}>
          {props.data[props.selectedIndex]?.roster.signed_at}
        </div>
        <div style={{ color: "#888888" }}>Venmo:</div>
        <div style={{ marginLeft: "100px" }}>
          {props.data[props.selectedIndex].user.venmoUserName}
        </div>
        <div style={{ color: "#888888" }}>Instagram:</div>
        <div style={{ marginLeft: "100px" }}>
          <InstagramLink
            style={{ width: "30px" }}
            id={props.data[props.selectedIndex].student_athlete.instagramData}
          />
        </div>
        <div style={{ color: "#888888" }}>Is International</div>
        <div style={{ marginLeft: "100px" }}>
          {props.data[props.selectedIndex]?.roster.is_international ? "Yes" : "No"}
        </div>
        <div style={{ color: "#888888" }}>Signed:</div>
        <div style={{ marginLeft: "100px" }}>
          {props.data[props.selectedIndex]?.roster.signed ? "Yes" : "No"}
        </div>
        <div style={{ color: "#888888" }}>Email:</div>
        <div style={{ marginLeft: "100px", overflowWrap: "break-word" }}>
          {props.data[props.selectedIndex].user.email}
        </div>
        <div style={{ color: "#888888" }}>Phone:</div>
        <div style={{ marginLeft: "100px" }}>
          {props.data[props.selectedIndex].student_athlete.phone}
        </div>
        <div style={{ color: "#888888" }}>Sport:</div>
        <div style={{ marginLeft: "100px" }}>
          <a style={{ "color": "#80a097", "textDecoration": "none" }} href={getGoogleLink(props.data[props.selectedIndex].roster.university, props.data[props.selectedIndex].roster.sport)} target="_blank" rel="noopener noreferrer">{props.data[props.selectedIndex].roster.sport}</a>
        </div>
        {/* <div style={{ color: "#888888" }}>Edit info:</div> */}
        <div style={{ marginLeft: "100px" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              navigate("/ballpark/athletes/" + btoa(props.data[props.selectedIndex].roster.idAthleteMerchInfo))
            }
          >
            Edit Info
          </Button>
        </div>
      </Box >
      {user && <ScoutTeam
        scoutData={props.data[props.selectedIndex].roster.university}
        refresh={props.reload}
        user={user}
      />}
      <div style={{ marginTop: "20px", color: "#868686", opacity: "87%" }}>
        Un-Matched Athletes
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          paddingTop: "10px",
          paddingBottom: "10px",
        }}
      >
        <Button
          disabled={props.loading}
          sx={{ backgroundColor: "success.dark", color: "text.primary" }}
          onClick={() => matchRecords("create")}
        >
          Add to Roster
        </Button>
        <Button
          disabled={props.loading}
          sx={{ backgroundColor: "error.main", color: "text.primary" }}
          onClick={() => setTransfer(true)}
        >
          Send to Transfer Portal
        </Button>
      </div>
      {
        props.data.map((athlete, index) => (
          <ListItem
            key={athlete.roster.idAthleteMerchInfo}
            sx={{
              backgroundColor:
                props.selectedIndex === index
                  ? "success.dark"
                  : "background.paper",
              marginBottom: "5px",
              maxWidth: "370px",
              padding: "unset",
              boxShadow:
                props.selectedIndex === index ? "0px 5px 8px darkgreen" : "unset",
            }}
          >
            <ListItemButton onClick={() => props.select(index)}>
              <ListItemAvatar>
                <Avatar src={athlete.user.profilePicture} />
              </ListItemAvatar>
              {(athlete.roster.jersey_number ? athlete.roster.jersey_number : " _ ") +
                " : " +
                athlete.roster.full_name +
                " " +
                athlete.roster.sport}
            </ListItemButton>
          </ListItem>
        ))
      }
      {transfer && <TransferModal
        style={{
          backgroundColor: "background.default",
          margin: "auto",
          marginTop: "10vh",
          padding: "20px",
          width: "40vw",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          borderRadius: "5px",
        }}
        open={transfer !== undefined}
        confirmTransfer={(reason) => {
          sendToTransferPortalAction(reason);
        }}
        close={() => {
          setTransfer(undefined);
        }} />}
      {action && (
        <AreYouSure
          style={{
            backgroundColor: "background.paper",
            margin: "auto",
            marginTop: "10vh",
            padding: "20px",
            width: "30vw",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            borderRadius: "5px",
          }}
          open={action !== undefined}
          message={buildAYSMessage(action)}
          yes={() => aYSYes()}
          no={() => setAction(undefined)}
        />
      )}
    </div >
  );
};

export default UnMatchedTable;
